<template>
	<div id="app">
		<navigators />
		
		<div v-bind:class="vue_class()"> <!-- vue-page-[login][dashboard][admin_panel] -->

			<div class="vue-router-container">
				<router-view  />
			</div>

			
		</div>
		
		
	</div>
</template>
<script>

import Vue from 'vue'
import router from '@/router'

import Vuex from 'vuex'
import { store } from './storage/vuex-store.js' 


import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'


import session from 'sessionstorage'



import cors from 'cors'

import axios from 'axios'
import apiconfig from '../static/api.config.js'
import kiwiweb_config from '../static/kiwiweb.config.json'

Vue.use(Vuex)
Vue.use(cors)









import { deviceDetect } from 'mobile-device-detect'







// jQuery 👇

window.$ = window.jQuery = require('jquery');

// jQuery ☝

// Materialize CSS 👇

import materializecss from '../static/css/main.css'

// Materialize CSS ☝





// DataTables 👇

import dtcss from '../static/datatables.css'
require( 'datatables.net' )
require( 'datatables.net-dt' )
require( 'datatables.net-editor' )
require( 'datatables.net-autofill-dt' )
require( 'datatables.net-buttons-dt' )
require( 'datatables.net-buttons/js/buttons.colVis.js' )
require( 'datatables.net-buttons/js/buttons.flash.js' )
require( 'datatables.net-buttons/js/buttons.html5.js' )
require( 'datatables.net-buttons/js/buttons.print.js' )
require( 'datatables.net-colreorder-dt' )
require( 'datatables.net-fixedcolumns-dt' )
require( 'datatables.net-fixedheader-dt' )
require( 'datatables.net-keytable-dt' )
require( 'datatables.net-responsive-dt' )
require( 'datatables.net-rowgroup-dt' )
require( 'datatables.net-rowreorder-dt' )
require( 'datatables.net-scroller-dt' )
require( 'datatables.net-select-dt' )

	// DataTable Extentions 👇

import select2css from '../static/select2/css/select2.css'
import '../static/select2/js/select2.js'
require ('../static/select2/js/editor.select2.js')

require('datejs')

	// DataTable Extentions ☝

// DataTables ☝



// Font Awesome 👇

import { library } from '@fortawesome/fontawesome-svg-core'

import { fab } from '@fortawesome/free-brands-svg-icons'

import { fas } from '@fortawesome/pro-solid-svg-icons'

import { far } from '@fortawesome/pro-regular-svg-icons'

import { fal } from '@fortawesome/pro-light-svg-icons'

import { fad } from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add(fab, fas, far, fal, fad)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

// Font Awesome ☝



// Component Imports 👇

import navigators from '@/components/navigators'

// Component Imports ☝





var vthis = this;



export default {
	name: 'App',
  	components: {
		navigators
	},
	watch:{
		

		$route: function(){

			
			
		}, 
		deep: false,
		immediate: true
	
	},
  	data() {
    	return{
			
			
			user_authenticated: session.getItem('user_authenticated'),
			window: {
				width: 0,
				height: 0
			},
			sidenav_open: '',
			sidenav_closed: ''
		}
  	},
	methods:{


		hasProduct() {
			return this.getProductsInCart.length > 0;
		},
		showPopupCart() {
			this.showOrHiddenPopupCart();
		},
		vue_class(){
			return 'vue-page-' + this.$route.name
		},
	},
	
	beforeCreate:function(){

	},
	created: function(){

		this.$store.dispatch('set_user_session')
		this.$store.dispatch('set_plant_info')
	

	},
	async mounted(){
		
		
		
	},
	update(){


		
	},
	beforeDestory(){
		
		
	},
	destroyed() {

		

	}
}
</script>




// WEBPACK FOOTER //
// src/App.vue